import action from './action'
import mutation from './mutation'
// import getters from './getters'

export default {
    state: {
        defaultPaymentMethod: ''
    },
    actions: action,
    mutations: mutation
    // getters
}